import { useState, useEffect } from 'react';
import Paginador from '../../components/Paginador';

// LA RULETA DE ESTE EVENTO.
//
// Vive en Promociones, junto al 2x1, el % y el cupón, porque es eso: una promoción de esta
// noche. Antes era una sola por boliche, con un evento "vinculado" que había que acordarse
// de cambiar; quedó andando para una noche pasada y sus cupones se usaron en la siguiente.

const POR_PAGINA = 100;
const INK = '#9A9A9A';
const SEG = ['#8B0F1A', '#C8102E', '#4A0810', '#A8101F', '#6B0F1A', '#E63946'];
let _id = 0;
const newId = () => 'p' + (++_id) + Date.now();
const soloNumeros = (v) => +String(v).replace(/[^0-9]/g, '') || 0;

export default function RuletaEvento({ event, api }) {
  const [cfg, setCfg] = useState(null);
  const [plays, setPlays] = useState({ metrics: {}, plays: [] });
  const [pag, setPag] = useState(1);
  const [saved, setSaved] = useState(false);

  const cargarTiradas = () => api.get('/api/roulette/plays?event_id=' + event.id).then(setPlays).catch(() => {});
  useEffect(() => {
    api.get('/api/roulette?event_id=' + event.id)
      .then(c => setCfg({ ...c, prizes: Array.isArray(c.prizes) ? c.prizes : [] }))
      .catch(() => {});
    cargarTiradas();
  }, [event.id]); // eslint-disable-line

  if (!cfg) return <div style={{ color: INK }}>Cargando…</div>;

  const set = (patch) => setCfg(c => ({ ...c, ...patch }));
  const setPrize = (id, patch) => set({ prizes: cfg.prizes.map(p => p.id === id ? { ...p, ...patch } : p) });
  const addPrize = () => set({ prizes: [...cfg.prizes, { id: newId(), name: 'NUEVO', percent: 0, probability: 0, active: true }] });
  const rmPrize = (id) => set({ prizes: cfg.prizes.filter(p => p.id !== id) });
  const activos = cfg.prizes.filter(p => p.active !== false);
  const totalProb = activos.reduce((a, p) => a + (Number(p.probability) || 0), 0);

  async function save() {
    // Prenderla sin premios haría aparecer una ruleta que no reparte nada.
    if (cfg.active && !activos.length) { alert('Para activarla cargá al menos un premio activo.'); return; }
    try {
      await api.put('/api/roulette', { event_id: event.id, active: cfg.active, expiry_date: cfg.expiry_date, prizes: cfg.prizes });
      setSaved(true); setTimeout(() => setSaved(false), 2000);
    } catch (e) { alert(e.message); }
  }

  const m = plays.metrics || {};
  const lista = plays.plays || [];
  const totalPags = Math.max(1, Math.ceil(lista.length / POR_PAGINA));
  const pagAct = Math.min(pag, totalPags);
  const desde = (pagAct - 1) * POR_PAGINA;
  const visibles = lista.slice(desde, desde + POR_PAGINA);

  return (
    <div className="lb-fade" style={{ paddingTop: 30 }}>
      <div className="tk-2col" style={{ display: 'grid', gridTemplateColumns: '1.4fr 1fr', gap: 24, alignItems: 'start' }}>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
          <div className="lb-card" style={{ padding: '18px 20px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 14 }}>
            <div>
              <div style={{ color: '#fff', fontWeight: 600 }}>Ruleta activa en este evento</div>
              <div style={{ fontSize: 12, color: INK, marginTop: 2, lineHeight: 1.45 }}>
                Aparece en la página de este evento. Para que salga también en la portada de tu web, elegila en Mi web → Secciones.
              </div>
            </div>
            <button onClick={() => set({ active: !cfg.active })} className={'lb-toggle__track ' + (cfg.active ? 'lb-toggle__track--on' : 'lb-toggle__track--off')} style={{ border: 0, flex: 'none' }}>
              <span className={'lb-toggle__knob ' + (cfg.active ? 'lb-toggle__knob--on' : 'lb-toggle__knob--off')} />
            </button>
          </div>

          <div className="lb-field" style={{ maxWidth: 260 }}>
            <div className="lb-label">Vencimiento de los cupones</div>
            <input className="lb-input" type="date" value={cfg.expiry_date ? String(cfg.expiry_date).slice(0, 10) : ''} onChange={e => set({ expiry_date: e.target.value })} />
            <div style={{ fontSize: 11, color: INK, marginTop: 6, lineHeight: 1.45 }}>Los cupones ganados solo sirven para este evento y hasta esta fecha.</div>
          </div>

          <div className="lb-card" style={{ padding: '6px 20px' }}>
            <div className="lb-row lb-th" style={{ gridTemplateColumns: '1.8fr 0.8fr 0.9fr 0.6fr 28px' }}>
              <span>Premio</span><span>% desc</span><span>Probab.</span><span>Activo</span><span></span>
            </div>
            {cfg.prizes.map(p => (
              <div key={p.id} className="lb-row" style={{ gridTemplateColumns: '1.8fr 0.8fr 0.9fr 0.6fr 28px' }}>
                <input className="lb-input ev-edit" value={p.name} onChange={e => setPrize(p.id, { name: e.target.value })} />
                <input className="lb-input ev-edit" inputMode="numeric" value={p.percent} onChange={e => setPrize(p.id, { percent: soloNumeros(e.target.value) })} />
                <input className="lb-input ev-edit" inputMode="numeric" value={p.probability} onChange={e => setPrize(p.id, { probability: soloNumeros(e.target.value) })} />
                <button onClick={() => setPrize(p.id, { active: !(p.active !== false) })} style={{ background: 'transparent', border: 0, cursor: 'pointer', color: p.active !== false ? '#2ecc71' : INK, fontSize: 18 }}>{p.active !== false ? '●' : '○'}</button>
                <button className="lb-iconbtn" onClick={() => rmPrize(p.id)}>✕</button>
              </div>
            ))}
            {cfg.prizes.length === 0 && <div style={{ padding: '14px 0 4px', color: INK, fontSize: 13 }}>Sin premios todavía.</div>}
            <div style={{ padding: '12px 0' }}>
              <button className="lb-btn lb-btn--ghost lb-btn--sm" onClick={addPrize}>+ Agregar premio</button>
            </div>
          </div>

          <div style={{ fontSize: 13, fontWeight: 600, color: totalProb === 100 ? '#2ecc71' : 'var(--red-300)' }}>
            Suma de probabilidades: {totalProb}% {totalProb === 100 ? '✓' : '· debe sumar 100%'}
          </div>
          <div style={{ fontSize: 11.5, color: INK, marginTop: -8, lineHeight: 1.45 }}>
            Un premio con 0% de descuento cuenta como "sin premio": la persona juega pero no se lleva cupón.
          </div>

          <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
            <button className="lb-btn lb-btn--primary lb-btn--sm" onClick={save}>Guardar ruleta</button>
            {saved && <span style={{ color: '#2ecc71', fontSize: 12 }}>Guardado ✓</span>}
          </div>
        </div>

        <div className="lb-card" style={{ padding: '24px', textAlign: 'center' }}>
          <div className="lb-eyebrow" style={{ marginBottom: 16 }}>Vista previa</div>
          <Rueda prizes={activos} />
        </div>
      </div>

      {/* Quiénes jugaron en ESTE evento, con su premio. */}
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 10, marginTop: 30, flexWrap: 'wrap' }}>
        <span className="lb-eyebrow">Tiradas de este evento</span>
        <button className="lb-btn lb-btn--ghost lb-btn--sm" onClick={cargarTiradas}>Actualizar</button>
      </div>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4,1fr)', gap: 14, marginTop: 14 }}>
        <Metrica label="Tiradas" value={m.tiradas || 0} />
        <Metrica label="Cupones otorgados" value={m.cupones || 0} />
        <Metrica label="Canjeados" value={m.canjeados || 0} />
        <Metrica label="Conversión" value={(m.conversion || 0) + '%'} accent />
      </div>

      <PorPremio prizes={cfg.prizes} plays={plays.plays || []} />

      <div className="lb-eyebrow" style={{ marginTop: 26, marginBottom: 10 }}>Detalle de tiradas</div>
      <div className="lb-card" style={{ padding: '6px 22px' }}>
        <div className="lb-row lb-th" style={{ gridTemplateColumns: '1.6fr 1.1fr 1fr 1fr 0.7fr' }}>
          <span>Email</span><span>Teléfono</span><span>Premio</span><span>Cupón</span><span>Estado</span>
        </div>
        {visibles.map(p => (
          <div key={p.id} className="lb-row" style={{ gridTemplateColumns: '1.6fr 1.1fr 1fr 1fr 0.7fr' }}>
            <span style={{ color: '#fff', fontSize: 13, overflow: 'hidden', textOverflow: 'ellipsis' }}>{p.email}</span>
            <span style={{ color: INK, fontSize: 13 }}>{p.phone}</span>
            <span style={{ color: INK, fontSize: 13 }}>{p.prize}</span>
            <span style={{ fontFamily: 'monospace', fontSize: 12, color: 'var(--red-400)' }}>{p.coupon_code || '—'}</span>
            <span><span className={'lb-status ' + (p.used ? 'lb-status--used' : 'lb-status--paid')}>{p.used ? 'Usado' : (p.coupon_code ? 'Activo' : '—')}</span></span>
          </div>
        ))}
        {lista.length === 0 && <div style={{ padding: '20px 0', textAlign: 'center', color: INK, fontSize: 13 }}>Todavía nadie jugó en este evento.</div>}
      </div>
      {totalPags > 1 && (
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 10, marginTop: 12 }}>
          <span style={{ fontSize: 12.5, color: INK }}>
            <b style={{ color: '#fff' }}>{desde + 1}–{Math.min(desde + POR_PAGINA, lista.length)}</b> de {lista.length} tiradas
          </span>
          <Paginador actual={pagAct} total={totalPags} onIr={setPag} />
        </div>
      )}
    </div>
  );
}

// RENDIMIENTO POR PREMIO.
//
// Dos preguntas distintas, y las dos importan:
//   · ¿CUÁNTO SALE? La probabilidad que cargaste es la intención; "sale" es lo que pasó de
//     verdad. Con pocas tiradas se separan solo por azar, pero si con cientos un premio
//     sale muy lejos de lo que pusiste, algo está mal cargado.
//   · ¿CUÁNTO CONVIERTE? De los cupones que repartió ese premio, cuántos se usaron para
//     comprar. Un premio que sale mucho y no lo canjea nadie es un premio que no mueve.
//
// Los premios se cruzan por NOMBRE, que es lo que queda guardado en la tirada. Un premio
// borrado (o renombrado) después de repartirse igual aparece, marcado, porque sus tiradas
// existieron y sus cupones pueden seguir dando vueltas.
function PorPremio({ prizes, plays }) {
  const total = plays.length;
  const porNombre = new Map();
  (prizes || []).forEach(p => {
    porNombre.set(p.name, {
      nombre: p.name, prob: Number(p.probability) || 0, pct: Number(p.percent) || 0,
      activo: p.active !== false, enConfig: true, tiradas: 0, cupones: 0, usados: 0,
    });
  });
  plays.forEach(p => {
    const nombre = p.prize || '—';
    if (!porNombre.has(nombre)) {
      porNombre.set(nombre, { nombre, prob: null, pct: null, activo: false, enConfig: false, tiradas: 0, cupones: 0, usados: 0 });
    }
    const f = porNombre.get(nombre);
    f.tiradas += 1;
    if (p.coupon_code) f.cupones += 1;
    if (p.used) f.usados += 1;
  });
  const filas = [...porNombre.values()].sort((a, b) => b.tiradas - a.tiradas || (b.prob || 0) - (a.prob || 0));
  if (!filas.length) return null;

  const GC = '1.6fr 0.9fr 1.1fr 0.9fr 0.9fr 1fr';
  return (
    <div style={{ marginTop: 26 }}>
      <div className="lb-eyebrow" style={{ marginBottom: 10 }}>Rendimiento por premio</div>
      <div className="lb-card tk-scroll-x" style={{ padding: '6px 22px' }}>
        <div className="lb-row lb-th" style={{ gridTemplateColumns: GC }}>
          <span>Premio</span><span>Cargado</span><span>Salió</span><span>Cupones</span><span>Canjeados</span><span>Conversión</span>
        </div>
        {filas.map(f => {
          const salio = total ? Math.round(f.tiradas / total * 1000) / 10 : 0;
          const conv = f.cupones ? Math.round(f.usados / f.cupones * 100) : null;
          // Se compara contra lo cargado solo con muestra suficiente: con 10 tiradas, una
          // diferencia de 20 puntos no dice nada.
          const desvio = f.prob != null && total >= 50 ? salio - f.prob : null;
          return (
            <div key={f.nombre} className="lb-row" style={{ gridTemplateColumns: GC, alignItems: 'center' }}>
              <span>
                <span style={{ color: '#fff', fontWeight: 600, fontSize: 13 }}>{f.nombre}</span>
                {!f.enConfig && <span style={{ display: 'block', fontSize: 10.5, color: INK }}>ya no está en la ruleta</span>}
                {f.enConfig && !f.activo && <span style={{ display: 'block', fontSize: 10.5, color: INK }}>desactivado</span>}
                {f.enConfig && f.pct === 0 && <span style={{ display: 'block', fontSize: 10.5, color: INK }}>sin premio</span>}
              </span>
              <span style={{ color: INK, fontSize: 13 }}>{f.prob != null ? f.prob + '%' : '—'}</span>
              <span style={{ color: '#fff', fontWeight: 600, fontSize: 13 }}>
                {salio}% <span style={{ color: INK, fontWeight: 400 }}>({f.tiradas})</span>
                {desvio != null && Math.abs(desvio) >= 5 && (
                  <span style={{ fontSize: 11, color: desvio > 0 ? '#ffb300' : 'var(--ink-600)', marginLeft: 6 }}>
                    {desvio > 0 ? '+' : ''}{Math.round(desvio)}
                  </span>
                )}
              </span>
              <span style={{ color: 'var(--ink-800)', fontSize: 13 }}>{f.cupones || '—'}</span>
              <span style={{ color: 'var(--ink-800)', fontSize: 13 }}>{f.usados || '—'}</span>
              <span style={{ color: conv == null ? INK : (conv >= 50 ? '#2ecc71' : '#fff'), fontWeight: conv == null ? 400 : 600, fontSize: 13 }}>
                {conv == null ? '—' : conv + '%'}
              </span>
            </div>
          );
        })}
      </div>
      <div style={{ marginTop: 8, fontSize: 11, color: INK, lineHeight: 1.5 }}>
        <b style={{ color: '#fff' }}>Cargado</b> = la probabilidad que le pusiste. <b style={{ color: '#fff' }}>Salió</b> = cuánto salió de verdad sobre {total} {total === 1 ? 'tirada' : 'tiradas'}.
        {' '}<b style={{ color: '#fff' }}>Conversión</b> = de los cupones que repartió ese premio, cuántos se usaron para comprar. Los premios sin cupón (0%) no convierten.
        {total < 50 && ' Con pocas tiradas, lo que sale todavía se mueve bastante por azar.'}
      </div>
    </div>
  );
}

function Rueda({ prizes }) {
  const n = prizes.length || 1;
  const R = 90, cx = 100, cy = 100;
  const seg = 360 / n;
  return (
    <svg viewBox="0 0 200 200" width="220" height="220" style={{ margin: '0 auto', display: 'block' }}>
      {prizes.map((p, i) => {
        const a0 = (i * seg - 90) * Math.PI / 180;
        const a1 = ((i + 1) * seg - 90) * Math.PI / 180;
        const x0 = cx + R * Math.cos(a0), y0 = cy + R * Math.sin(a0);
        const x1 = cx + R * Math.cos(a1), y1 = cy + R * Math.sin(a1);
        const large = seg > 180 ? 1 : 0;
        const mid = (a0 + a1) / 2;
        const tx = cx + R * 0.6 * Math.cos(mid), ty = cy + R * 0.6 * Math.sin(mid);
        return (
          <g key={p.id || i}>
            <path d={'M' + cx + ',' + cy + ' L' + x0 + ',' + y0 + ' A' + R + ',' + R + ' 0 ' + large + ' 1 ' + x1 + ',' + y1 + ' Z'} fill={SEG[i % SEG.length]} stroke="#000" strokeWidth="1" />
            <text x={tx} y={ty} fill="#fff" fontSize="7" fontWeight="700" textAnchor="middle" transform={'rotate(' + ((i + 0.5) * seg) + ',' + tx + ',' + ty + ')'}>{(p.name || '').slice(0, 10)}</text>
          </g>
        );
      })}
      <circle cx={cx} cy={cy} r="14" fill="#0A0A0A" stroke="#fff" strokeWidth="2" />
      <polygon points="100,4 94,18 106,18" fill="#fff" />
    </svg>
  );
}

function Metrica({ label, value, accent }) {
  return (
    <div className="lb-card" style={{ padding: '16px 18px' }}>
      <div className="lb-eyebrow">{label}</div>
      <div style={{ fontFamily: 'var(--font-display)', fontWeight: 800, fontSize: 24, color: accent ? 'var(--red-400)' : '#fff', marginTop: 6 }}>{value}</div>
    </div>
  );
}
